import PropTypes from 'prop-types';
import {
  Avatar,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import UserProfileModal from 'components/navbar/UserProfileModal';
import routes from 'routes';
import { useAuth } from '../../contexts/AuthContext';

export default function HeaderLinks({ secondary, showSearch, sidebarCollapsed, setSidebarCollapsed }) {
  const navigate = useNavigate();
  const { isAuthenticated, logout, displayName, user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    localStorage.setItem('isAuthenticated', isAuthenticated);
  }, [isAuthenticated]);

  const menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );

  const handleLogout = () => {
    logout();
    navigate('/auth/sign-in');
  };

  return (
    <>
      <Flex
        w={{ sm: '100%', md: 'auto' }}
        alignItems="center"
        flexDirection="row"
        bg={menuBg}
        flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
        p="10px"
        borderRadius="30px"
        boxShadow={shadow}
      >
        {showSearch && <SearchBar me="10px" borderRadius="30px" />}
        <SidebarResponsive
          routes={routes}
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        />
        <Menu>
          <MenuButton p="0px">
            <Avatar
              _hover={{ cursor: 'pointer' }}
              color="white"
              name={displayName}
              bg="#003064"
              size="sm"
              w="40px"
              h="40px"
            />
          </MenuButton>
          <MenuList
            boxShadow={shadow}
            p="0px"
            mt="10px"
            borderRadius="20px"
            bg={menuBg}
            border="none"
          >
            <Flex w="100%" mb="0px" direction="column" borderBottom="1px solid" borderColor={borderColor}>
              <Text
                ps="20px"
                pt="16px"
                pb={user?.username && user.username !== displayName ? '4px' : '10px'}
                w="100%"
                fontSize="sm"
                fontWeight="700"
                color={textColor}
              >
                Hola, {displayName}
              </Text>
              {user?.username && user.username !== displayName && (
                <Text ps="20px" pb="10px" fontSize="xs" color="gray.500">
                  @{user.username}
                </Text>
              )}
            </Flex>
            <Flex flexDirection="column" p="10px">
              <MenuItem
                _hover={{ bg: 'gray.50' }}
                _focus={{ bg: 'gray.50' }}
                borderRadius="8px"
                px="14px"
                onClick={onOpen}
              >
                <Text fontSize="sm">Mi perfil</Text>
              </MenuItem>
              <MenuItem
                _hover={{ bg: 'none' }}
                _focus={{ bg: 'none' }}
                color="red.400"
                borderRadius="8px"
                px="14px"
                onClick={handleLogout}
              >
                <Text fontSize="sm">Cerrar sesión</Text>
              </MenuItem>
            </Flex>
          </MenuList>
        </Menu>
      </Flex>

      <UserProfileModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}

HeaderLinks.propTypes = {
  secondary: PropTypes.bool,
  showSearch: PropTypes.bool,
  sidebarCollapsed: PropTypes.bool,
  setSidebarCollapsed: PropTypes.func,
};
